module.exports = __webpack_public_path__ + "static/media/SF_bm_sekundaerlogo_postale_innlandet_neg.caf77a49.png";